import {Flex, Spin} from 'antd';
import React from 'react';

const Loader: React.FC<{
  isHome?: boolean;
  topMargin?: boolean;
  description?: string;
}> = ({isHome = false, topMargin = false, description = ''}) => {
  const hasDescription = Boolean(description);

  return (
    <Flex
      align="center"
      gap="middle"
      justify="center"
      vertical={hasDescription}
      className={`loader ${
        isHome ? 'fullScreen' : topMargin ? 'topMargin' : ''
      }`}
    >
      <Spin size="large" />
      {hasDescription ? (
        <span className="loader__description">{description}</span>
      ) : null}
    </Flex>
  );
};

export default Loader;
